// extracted by mini-css-extract-plugin
export default {"whiteFill":"PG_whiteFill__EI4wc"};